module.exports = __webpack_public_path__ + "static/media/chiapas_Montebello_trigoestandar.9e39333d.png";